export default __webpack_public_path__ + "static/media/icon--outdoor.f9184caa.svg";